import React from 'react';
import config from '../../../../config';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Button, Col, Row } from 'react-bootstrap';
import { formatImageForBucket, customFormatter } from 'util/Utils';
import classNames from 'classnames';
import _ from 'lodash';

export const RMAProductsSelectionScreen = (props) => {
  const { screensData } = props;
  const {RMAProductsToDisplay = []} = screensData.RMAProductsData || {};

  return (
    <Row data-testid="screen-content" className="screen-content">
      <Col md={6} xs={6} className={classNames('top10 align-center')}>
        <div>
          <div>
            <div className="purple font-size-19 text-bold text-center bot20">{'Please select which item you are posting'}</div>

            <BootstrapTable
              data={RMAProductsToDisplay}
              hover={true}
              style={{ maxHeight: 1000 }}
              bordered={false}
            >
              <TableHeaderColumn dataField="_id" isKey={true} hidden={true} autoValue={true} hiddenOnInsert>
                Id
              </TableHeaderColumn>

              <TableHeaderColumn
                width="60px"
                editable={false}
                columnClassName="rma-product-column"
                dataFormat={customFormatter}
                formatExtraData={{
                  path: ['getObject'],
                  format: (item) => {
                    return renderRMAProductRow(item, props);
                  },
                }}
                dataAlign="center"
              >
                Products
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
        <div
          onClick={() => props.selectRMAProduct({ rmaProductNotFound: true, RMAProductBrand: screensData.RMAProductsData.GBGProductsBrand})}
          className="cursor-pointer  font-size-19 top20 text-center purple underlineText"
        >
          {'None of this, an alternate item was received'}
        </div>
      </Col>
    </Row>
  );
};


function renderRMAProductRow(item, props) {

  const { RMAItemsForGBGProduct = [] } = item;
  const { GBGProductImages = [], Brand = '', Model = '' } = item.GBGProductRecord;
  const GBGProductNotAvailable = Brand == '';
  const productName = Brand ? `${Brand} ${Model}` : `${item.RMAProductBrand} ${item.RMAProductModel}`;
  const metadata = (item.RMAVendorMetaData || {})
  // Change this when we add more partners
  const vendorProductData = metadata.arktx || metadata.articleName || 'n/a'
  const metadataImageUrl =  metadata.articleImageUrl || null
  const serverURL = config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '';
  let imageUrl = GBGProductImages[0] && GBGProductImages[0].URL ? formatImageForBucket(GBGProductImages[0].URL) : metadataImageUrl  || `${serverURL}/theme/assets/no-image-available.png`
  const unableStatus = ["unable_to_sell","additional_item_unable_to_sell", "additional_item_not_found"]
  return (
    <Row
      onClick={() => {

        if(item.alreadyPosted || unableStatus.includes(item.RMAProductStatus)) {
          return;
        }

        props.selectRMAProduct(item);
      }}
      className={classNames('rma-product-box pleft10 ptop15 pbot10 pright10', {
        'grayed-out': item.alreadyPosted || unableStatus.includes(item.RMAProductStatus),
      })}
      disabled={item.alreadyPosted}
      style={{}}
    >
      <Col xs={12} className="text-left">
        {RMAItemsForGBGProduct.length > 0 && (
          <div className="text-in-circle font-size-19 pull-right">{RMAItemsForGBGProduct.length}</div>
        )}
        <div className="pull-left right15">
          <img
            style={{
              width: 150,
              height: 150,
            }}
            src={imageUrl}
          />
        </div>
        <div className="font-size-19">{productName == "Unknown To sell"? "Unable to Sell" : productName} </div>
        {GBGProductNotAvailable && <div className="font-size-18 top10">{vendorProductData}</div>}
        {GBGProductNotAvailable && <div className="font-size-18 top10"></div>}
        { (item.alreadyPosted || unableStatus.includes(item.RMAProductStatus)) && <div className="font-size-18 top10">Already Posted</div>}
      </Col>
    </Row>
  );
}
